import { getRailwayOptions, listPointCandidates } from "../repo/itineraryRepo";
import { getRailwayTransfers } from "../repo/itineraryRailwayTransferRepo";

/** 供其他功能复用铁路选择器的只读查询能力，不暴露行程保存或插入操作。 */
export const itineraryRailwayQueries = { getRailwayOptions, getRailwayTransfers, listCandidates: listPointCandidates };
